import { ContainerModule } from 'inversify';
import { CourseCompletionService, CourseCompletionServiceSymbol } from './course-completion-service'

export const courseCompletionServiceModule = new ContainerModule((bind) => {
  bind(CourseCompletionServiceSymbol).to(CourseCompletionService).inSingletonScope();
});
